import React from 'react';
import { FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';

// Reusable decision radio group used across forms and previews.
// Props:
// - input: optional react-final-form input object ({ name, value, onChange })
// - disabled: boolean
// - translate: optional translate function
// - name: fallback name if input not provided
// - onChange: fallback change handler if input not provided
const DecisionRadioGroup = ({ input, meta, disabled = false, translate, name, onChange, labels }) => {
	const value = input ? (input.value ?? '') : '';
	const handleChange = (e) => {
		const v = e.target.value;
		if (input && input.onChange) {
			input.onChange(v);
		} else if (onChange) {
			onChange(v);
		}
	};

	// labels can be passed as an array [labelForApproved, labelForDenied]
	const approvedLabel = (labels && labels[0] && labels[0].trim()) ? labels[0] : (translate ? translate(labels[0]) : 'Approve');
	const deniedLabel = (labels && labels[1] && labels[1].trim()) ? labels[1] : (translate ? translate(labels[1]) : 'Deny');

	return (
		<FormControl component="fieldset" fullWidth disabled={disabled}>
			<RadioGroup
				row
				name={input ? input.name : name}
				value={value}
				onChange={handleChange}
			>
				<FormControlLabel
					value="approved"
					control={<Radio sx={{ p: '0px 9px' }} />}
					label={String(approvedLabel)}
				/>
				<FormControlLabel
					value="denied"
					control={<Radio sx={{ p: '0px 9px' }} />}
					label={String(deniedLabel)}
				/>
			</RadioGroup>
		</FormControl>
	);
}

export default DecisionRadioGroup;
